import styled from "styled-components";

export const TBody = styled.div`
  flex: 1;
  position: relative;
`;

export default TBody;
